import { render, staticRenderFns } from "./ReportUpgrader.vue?vue&type=template&id=54e3850e&lang=html&"
import script from "./ReportUpgrader.vue?vue&type=script&lang=js&"
export * from "./ReportUpgrader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports